import React, { useState } from 'react'
import SnackbarProvider from 'react-simple-snackbar'
import { useSnackbar } from 'react-simple-snackbar'
import { Container, Row, Col } from 'react-bootstrap'
import LayoutCustom from "../components/LayoutCustom";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import postFeedback from "../components/PostFeedback";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PlumsailForm from '../components/PlumsailForm';
const $ = require("jquery");

const ContactUs = () => {
    return (
        <SnackbarProvider>
            <ContactUsHandler />
        </SnackbarProvider>
    )
}

class CustomDropdown extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var x, i, j, l, ll, selElmnt, a, b, c

        /* look for any elements with the class "custom-select" */
        x = document.getElementsByClassName("custom-select")
        l = x.length

        for (i = 0; i < l; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0]
            ll = selElmnt.length

            /* for each element, create a new div that will act as the selected item */
            a = document.createElement("div")
            a.setAttribute("class", "select-selected app-selected-default")
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
            x[i].appendChild(a)

            /* for each element, create a new div that will contain the option list */
            b = document.createElement("div")
            b.setAttribute("class", "select-items select-hide")

            for (j = 1; j < ll; j++) {
                /* for each option in the original select element, create a new div that will act as an option item */
                c = document.createElement("div")
                c.innerHTML = selElmnt.options[j].innerHTML

                c.addEventListener("click", function (e) {
                    /* when an item is clicked, update the original select box, and the selected item */
                    var y, i, k, s, h, sl, yl
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0]
                    sl = s.length
                    h = this.parentNode.previousSibling

                    for (i = 0; i < sl; i++) {
                        if (s.options[i].innerHTML === this.innerHTML) {
                            s.selectedIndex = i
                            h.innerHTML = this.innerHTML
                            y = this.parentNode.getElementsByClassName("same-as-selected")
                            yl = y.length

                            for (k = 0; k < yl; k++) {
                                y[k].removeAttribute("class")
                            }

                            this.setAttribute("class", "same-as-selected")
                            break
                        }
                    }
                    h.click()
                })
                b.appendChild(c)
            }
            x[i].appendChild(b)

            a.addEventListener("click", function (e) {
                /* when the select box is clicked, close any other select boxes, and open/close the current select box:*/
                e.stopPropagation()
                closeAllSelect(this)
                this.nextSibling.classList.toggle("select-hide")
                this.classList.toggle("select-arrow-active")
                if (a.innerHTML === "I'm interested in…") {
                    this.classList.remove("app-selected-default");
                    this.classList.add("app-selected-default");
                } else {
                    this.classList.remove("app-selected-default");
                }
            })
        }

        function closeAllSelect(elmnt) {
            /* a function that will close all select boxes in the document, except the current select box */
            var x, y, i, xl, yl, arrNo = []
            x = document.getElementsByClassName("select-items")
            y = document.getElementsByClassName("select-selected")
            xl = x.length
            yl = y.length

            for (i = 0; i < yl; i++) {
                if (elmnt === y[i]) {
                    arrNo.push(i)
                } else {
                    y[i].classList.remove("select-arrow-active")
                }
            }

            for (i = 0; i < xl; i++) {
                if (arrNo.indexOf(i)) {
                    x[i].classList.add("select-hide")
                }
            }
        }

        /* if the user clicks anywhere outside the select box, then close all select boxes */
        document.addEventListener("click", closeAllSelect);
    }

    render() {
        return(
            <div className="custom-select">
                <select name="choice">
                    <option value="">I'm interested in…</option>
                    <option value="Appvity">Appvity</option>
                    <option value="eProducts">eProducts</option>
                    <option value="Services">Services</option>
                    <option value="Sales">Sales</option>
                    <option value="Solutions">Solutions</option>
                    <option value="Support">Support</option>
                    <option value="Technical concern">Technical concern</option>
                    <option value="Others">Others</option>
                </select>
            </div>
        )
    }
}

function clearFieldData() {
    return new Promise(resolve => {
        setTimeout(resolve, 1000);
    });
}

const initialState = {
    name: "",
    email: "",
    subject: "",
    choice: "",
    message: ""
};

const ContactUsHandler = () => {
    const [ { name, email, subject, message }, setState ] = useState(initialState);

    const clearState = () => {
        setState({ ...initialState });
        setStartDate();
    };

    const onChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({ ...prevState, [name]: value }));
        if (name === "name") {
            handleNameValidation(nameStatus, value);
        } if (name === "email") {
            handleEmailValidation(emailStatus, value)
        } else if (name === "subject") {
            handleSubjectValidation(subjectStatus, value);
        } else if (name === "message") {
            handleMessageValidation(messageStatus, value);
        }
    };

    const [ openSnackbar, closeSnackbar ] = useSnackbar()
    const [ nameStatus, setNameStatus ] = useState("name")
    const [ emailStatus, setEmailStatus ] = useState("email")
    const [ subjectStatus, setSubjectStatus ] = useState("subject")
    const [ choiceStatus, setChoiceStatus ] = useState("")
    const [ messageStatus, setMessageStatus ] = useState("message")
    const [ dateValidation, setDateValidation ] = useState()

    const [ startDate, setStartDate ] = useState();
    const [ errors, setErrors ] = useState({});
    const [ errorsVI, setErrorsVI ] = useState({});

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }

    function formatDate(date) {
        return [
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
            date.getFullYear(),
        ].join('/');
    }

    // method to validate values 
    const handleValidation = (nameStatus, name, emailStatus, email, subject, subjectStatus, choiceStatus, message, messageStatus, dateValidation) => {
        let errors = {};
        let errorsVI = {};
        let formIsValid = true;

        // name check if name is empty or not
        if (!name) {
            formIsValid = false;
            errors[nameStatus] = "Please enter your Name";
            errorsVI[nameStatus] = "Xin vui lòng nhập Tên";
        } 
        // else {
        //     // name should not contain special char
        //     if (typeof name !== "undefined") {
        //         if(name.match(/[&\/\\#,+()$~%.'":*?<>{}]/g)) {
        //             formIsValid = false;
        //             errors[nameStatus] = "You have entered an invalid name with special character. Please try again.";
        //         }
        //     }
        // }
        setNameStatus(nameStatus)

        // email should not be empty
        if (!email) {
            formIsValid = false;
            errors[emailStatus] = "Please enter your Email";
            errorsVI[emailStatus] = "Xin vui lòng nhập Email";
        } else {
            // validating email
            if (typeof email !== "undefined") {
                let lastAtPos = email.lastIndexOf('@');
                let lastDotPos = email.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
                    formIsValid = false;
                    errors[emailStatus] = "You have entered an invalid email address. Please try again";
                    errorsVI[emailStatus] = "Xin vui lòng nhập địa chỉ email hợp lệ";
                }
            }
        }
        setEmailStatus(emailStatus)

        // subject check if subject is empty or not
        if (!subject) {
            formIsValid = false;
            errors[subjectStatus] = "Please enter your Subject";
            errorsVI[subjectStatus] = "Xin vui lòng nhập Tiêu Đề";
        } 
        setSubjectStatus(subjectStatus)

        //because dropdown custom is select option fake so can't pass data normally
        const choice = document.querySelector('.app-section-contactus .app-contactus-detail .app-contactus-left .custom-select .select-selected').innerHTML;
        const choiceVal = (choice !== "I'm interested in…" || choice !== "Chủ Đề") ? choice : "";
        choiceStatus = choiceVal;
        setChoiceStatus(choiceStatus)

        if (choiceStatus === "I'm interested in…" || choiceStatus === "Chủ Đề") {
            formIsValid = false;
            errors[choiceStatus] = "Please select an option"
            errorsVI[choiceStatus] = "Xin vui lòng chọn Chủ Đề";
        }

        // message check if message is empty or not
        if (!message) {
            formIsValid = false;
            errors[messageStatus] = "Please enter your Message";
            errorsVI[messageStatus] = "Xin vui lòng nhập Nội dung";
        } 
        setMessageStatus(messageStatus)

        if (startDate) {
            if (formatDate(yesterday) !== formatDate(startDate)) {
                formIsValid = false;
                errors[dateValidation] = "Date validation is not correct. Please enter yesterday's Date again"
                errorsVI[dateValidation] = "Xác thực ngày không chính xác. Vui lòng nhập ngày hôm qua";
            }
        } else {
            formIsValid = false;
            errors[dateValidation] = "Please enter yesterday's Date"
            errorsVI[dateValidation] = "Xin vui lòng nhập ngày hôm qua";
        }
        setDateValidation(dateValidation);

        if (formIsValid === true) {
            // fetch('http://localhost:3000/contact-us', {
            //     method: 'POST',
            //     headers: {
            //         "Content-Type": "application/json"
            //     },
            //     body: JSON.stringify({
            //         "name": name,
            //         "email": email,
            //         "subject": subject,
            //         "choice": choiceVal,
            //         "message": message,
            //     })
            // })
            // .then(res => res.json())
            // .then(res => {
            //     openSnackbar("We have received your message. Thank you for contacting us.")
            // })
            // .catch((error) => {
            //     openSnackbar("Send mail failed. Please try again !!!")
            // });

            var data = {};
            data["type"] = "contact";
            data["name"] = name;
            data["from"] = email;
            data["subject"] = subject;
            data["topic"] = choiceVal;
            message = message.replace(/\n/gi, "<br/>");
            data["message"] = message;
            
            postFeedback(`${process.env.feedbackAPI}`, data, 
            function(response) {
                if ($("body").hasClass("app-en-lang")) {
                    openSnackbar("We have received your message. Thank you for contacting us.")
                } else if ($("body").hasClass("app-vi-lang")) {
                    openSnackbar("Chúng tôi đã nhận được yêu cầu của bạn. Xin cảm ơn.")
                }
                clearFieldData().then(clearState());
                
		        var lang = window.sessionStorage.getItem("lang");
                if(lang == "vi"){
                    $(".app-section-contactus .app-contactus-detail .app-contactus-left .custom-select .select-selected").each ( function (){
                        $(this).html("Chủ Đề");
                    });
                }
                else {
                    $(".app-section-contactus .app-contactus-detail .app-contactus-left .custom-select .select-selected").html("I'm interested in…");
                }
                $(".app-section-contactus .app-contactus-detail .app-contactus-left .custom-select .select-selected").addClass("app-selected-default");
            },
            function(error) {
                if ($("body").hasClass("app-en-lang")) {
                    openSnackbar("Send mail failed. Please try again !!!")
                } else if ($("body").hasClass("app-vi-lang")) {
                    openSnackbar("Đã có lỗi xảy ra trong quá trình gửi email. Xin vui lòng thử lại.")
                }
            });
        }

        setErrors(errors);
        setErrorsVI(errorsVI);
        return formIsValid;
    }

    const handleSubmit = e => {
        e.preventDefault();
        handleValidation(nameStatus, name, emailStatus, email, subject, subjectStatus, choiceStatus, message, messageStatus, dateValidation);
    }

    const handleNameValidation = (nameStatus, name) => {
        // name check if name is empty or not 
        if (name === "") { 
            errors[nameStatus] = "Please enter your Name"; 
            errorsVI[nameStatus] = "Xin vui lòng nhập Tên"; 
        } else {
            delete errors[nameStatus];
            delete errorsVI[nameStatus];
        }
        setNameStatus(nameStatus) 
        setErrors(errors); 
        setErrorsVI(errorsVI); 
    }

    const handleEmailValidation = (emailStatus, email) => {
        // email should not be empty
        if (!email) {
            errors[emailStatus] = "Please enter your Email";
            errorsVI[emailStatus] = "Xin vui lòng nhập Email";
        } else {
            delete errors[emailStatus];
            delete errorsVI[emailStatus];
            // validating email
            if (typeof email !== "undefined") {
                let lastAtPos = email.lastIndexOf('@');
                let lastDotPos = email.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
                    errors[emailStatus] = "You have entered an invalid email address. Please try again";
                    errorsVI[emailStatus] = "Xin vui lòng nhập địa chỉ email hợp lệ";
                } else {
                    delete errors[emailStatus];
                    delete errorsVI[emailStatus];
                }
            }
        }
        setEmailStatus(emailStatus)
        setErrors(errors); 
        setErrorsVI(errorsVI); 
    }

    const handleSubjectValidation = (subjectStatus, subject) => {
        // subject check if subject is empty or not
        if (!subject) {
            errors[subjectStatus] = "Please enter your Subject";
            errorsVI[subjectStatus] = "Xin vui lòng nhập Tiêu Đề";
        } else {
            delete errors[subjectStatus];
            delete errorsVI[subjectStatus];
        }
        setSubjectStatus(subjectStatus)
        setErrors(errors); 
        setErrorsVI(errorsVI); 
    }

    const handleMessageValidation = (messageStatus, message) => {
        // message check if message is empty or not
        if (!message) {
            errors[messageStatus] = "Please enter your Message";
            errorsVI[messageStatus] = "Xin vui lòng nhập Nội dung";
        } else {
            delete errors[messageStatus];
            delete errorsVI[messageStatus];
        }
        setMessageStatus(messageStatus)
        setErrors(errors); 
        setErrorsVI(errorsVI); 
    }

	return (
        <LayoutCustom>
            <SEO title="Contact Us" description="Contact Appvity if you have any question about eProducts, services, or product payment." meta={[{ name: `keywords`, content: ["Appvity contact us", "question about Appvity products", "question about eProducts"] }]} pathname="/contact-us" />                        
            <div className="main-content-padding">
                <div className="app-general-seciton app-section-contactus" data-sal="fade" data-sal-duration="1000" data-sal-delay="100" data-sal-easing="ease">
                    <Container>
                        {/* <div className="app-title">
                            <h2 className="app-data-en">Contact Us</h2>
                            <h2 className="app-data-vi">Liên Hệ</h2>
                        </div> */}
                        <div className="app-contactus-detail">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <PlumsailForm />
                                    {/* <form onSubmit={handleSubmit} noValidate>
                                        <div className="app-contactus-left">
                                            <input id='app-contactus-name'
                                                type="text" 
                                                placeholder="Name" 
                                                name="name" 
                                                value={name} 
                                                onChange={onChange} 
                                                required 
                                                onBlur={onChange}
                                            />
                                            <h6 className="app-data-en app-contact-us-errors-label">{errors[nameStatus]}</h6>
                                            <h6 className="app-data-vi app-contact-us-errors-label">{errorsVI[nameStatus]}</h6>
                                            <input id='app-contactus-email'
                                                type="email"
                                                placeholder="Email"
                                                name="email"
                                                value={email} 
                                                onChange={onChange} 
                                                required 
                                                onBlur={onChange}
                                            />
                                            <h6 className="app-data-en app-contact-us-errors-label">{errors[emailStatus]}</h6>
                                            <h6 className="app-data-vi app-contact-us-errors-label">{errorsVI[emailStatus]}</h6>
                                            <input id='app-contactus-subject'
                                                type="text"
                                                placeholder="Subject"
                                                name="subject"
                                                value={subject} 
                                                onChange={onChange} 
                                                required 
                                                onBlur={onChange}
                                            />
                                            <h6 className="app-data-en app-contact-us-errors-label">{errors[subjectStatus]}</h6>
                                            <h6 className="app-data-vi app-contact-us-errors-label">{errorsVI[subjectStatus]}</h6>
                                            <CustomDropdown name="choice" />
                                            <h6 className="app-data-en app-contact-us-errors-label">{errors[choiceStatus]}</h6>
                                            <h6 className="app-data-vi app-contact-us-errors-label">{errorsVI[choiceStatus]}</h6>
                                            <textarea id='app-contactus-message'
                                                rows="6"
                                                placeholder="Message"
                                                name="message"
                                                value={message} 
                                                onChange={onChange} 
                                                required 
                                                onBlur={onChange}
                                            ></textarea>
                                            <h6 className="app-data-en app-contact-us-errors-label">{errors[messageStatus]}</h6>
                                            <h6 className="app-data-vi app-contact-us-errors-label">{errorsVI[messageStatus]}</h6>
                                            <label id="app-contact-us-label-validation" className="app-contact-us-label-validation">Please enter yesterday's date for validation (MM/DD/YYYY)</label>
                                            <div className="app-data-en">
                                                <DatePicker 
                                                    selected={startDate} 
                                                    onChange={date => setStartDate(date)} 
                                                    placeholderText="Date"
                                                />
                                            </div>
                                            <div className="app-data-vi">
                                                <DatePicker 
                                                    selected={startDate} 
                                                    onChange={date => setStartDate(date)} 
                                                    placeholderText="Ngày"
                                                />
                                            </div>
                                            <h6 className="app-data-en app-contact-us-errors-label">{errors[dateValidation]}</h6>
                                            <h6 className="app-data-vi app-contact-us-errors-label">{errorsVI[dateValidation]}</h6>
                                            <input id="app-contactus-btn"
                                                className="app-data-en app-contactus-btn"
                                                type="submit"
                                                value="Send Message"
                                            />
                                            <input id="app-contactus-btn"
                                                className="app-data-vi app-contactus-btn"
                                                type="submit"
                                                value="Gửi"
                                            />
                                        </div>
                                    </form> */}
                                </Col>
                                {/* <Col xs={12} md={12} lg={7}></Col> */}
                            </Row>
                        </div>
                    </Container>
                    <div className="footer-custom">
                        <Footer />
                    </div>
                </div>
            </div>
        </LayoutCustom>
	)
}

export default ContactUs